import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "inventaire__left__items" }
const _hoisted_2 = ["id"]
const _hoisted_3 = { class: "size__h6 weight__bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      id: _ctx.group,
      class: "inventaire__left__accord"
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["inventaire__left__accord-title", { 'inventaire__left__accord-title-active': _ctx.isActive }]),
        "on:Onclick": _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleClass()))
      }, [
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.title), 1)
      ], 34),
      _createElementVNode("div", {
        class: _normalizeClass(["inventaire__left__accord-content", { 'inventaire__left__accord-content-active': _ctx.isActive }])
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 2)
    ], 8, _hoisted_2)
  ]))
}